import React, { createContext, useContext, useState, useCallback } from 'react';
import Papa from 'papaparse';

const DictionaryContext = createContext();

export const DictionaryProvider = ({ children }) => {
  const [dictionary, setDictionary] = useState({});
  const [loadingFiles, setLoadingFiles] = useState({});

  const loadDictionary = useCallback(async (fileName) => {
    // Evita recarregar se já existe ou está carregando
    if (dictionary[fileName] || loadingFiles[fileName]) {
      return;
    }

    try {
      setLoadingFiles(prev => ({ ...prev, [fileName]: true }));
      
      const response = await fetch(`/data/${fileName}.tsv`);
      if (!response.ok) {
          throw new Error(`Arquivo não encontrado: ${fileName}`);
      }
      
      const text = await response.text();

      Papa.parse(text, {
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
        complete: (result) => {
          // --- CORREÇÃO 1: Normalizar chaves para minúsculo ---
          // Isso garante que se o arquivo tiver "ID" ou "Nome", funcionará como "id" e "nome"
          const normalizedData = result.data.map(item => {
              const newItem = {};
              Object.keys(item).forEach(key => {
                  newItem[key.toLowerCase().trim()] = item[key];
              });
              return newItem;
          });

          setDictionary(prev => ({ ...prev, [fileName]: normalizedData }));
          setLoadingFiles(prev => ({ ...prev, [fileName]: false }));
        },
      });
    } catch (error) {
      console.error(`Erro ao carregar o dicionário ${fileName}:`, error);
      setLoadingFiles(prev => ({ ...prev, [fileName]: false }));
    }
  }, [dictionary, loadingFiles]);

  const getDescricao = useCallback((fileName, id) => {
    const dict = dictionary[fileName];
    if (!dict) {
      return id; // Retorna o ID se o dicionário não carregou
    }
    
    // Converte ID para string para comparação segura
    const idStr = String(id);
    
    // Procura o item (comparando strings para evitar problemas de tipo)
    const item = dict.find(row => String(row.id) === idStr);
    
    if (item) {
        // --- CORREÇÃO 2: Busca Inteligente de Campos de Texto ---
        // Tenta encontrar o campo de descrição em várias colunas comuns
        return item.descricao || item.nome || item.desc || item.unidade || item.label || id;
    }
    
    return id; // Retorna o ID se não encontrar o item
  }, [dictionary]);

  const isLoading = Object.values(loadingFiles).some(status => status === true);

  const value = {
    dictionary,
    isLoading,
    loadDictionary,
    getDescricao,
    // Verifica se existe E tem dados
    isLoaded: (fileName) => !!dictionary[fileName] && dictionary[fileName].length > 0
  };

  return (
    <DictionaryContext.Provider value={value}>
      {children}
    </DictionaryContext.Provider>
  );
};

export const useDictionary = () => {
  const context = useContext(DictionaryContext);
  if (context === undefined) {
    throw new Error('useDictionary deve ser usado dentro de um DictionaryProvider');
  }
  return context;
};